import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";
import { useAgencyAccounts } from "@/hooks/useAgencyAccounts";
import { MobileAccountSwitchSheet } from "./MobileAccountSwitchSheet";

/**
 * Barra do topo das telas raiz. Só existe visualmente quando o usuário pode
 * operar mais de uma conta (agency user ou account user multi-conta) — nesse
 * caso mostra a conta atual e abre o seletor. Caso contrário fica só o espaço
 * da safe area, para o header da tela não encostar na status bar.
 */
export const MobileTopBar = () => {
  const { t } = useTranslation("common");
  const [switchOpen, setSwitchOpen] = useState(false);
  const { accounts, currentAccount, isAgencyUser, hasMultipleAccounts, switchAccount, loading } =
    useAgencyAccounts();

  // Mesma condição do seletor da LeftNavigation no web
  const canSwitchAccount =
    (isAgencyUser && accounts.length > 0) || (hasMultipleAccounts && accounts.length > 1);

  if (!canSwitchAccount) {
    return <div className="shrink-0 bg-card pt-[env(safe-area-inset-top)]" />;
  }

  const accountName = currentAccount?.nome || t("nav.selectAccount");

  return (
    <>
      <header className="flex shrink-0 items-center border-b border-border bg-card px-2 pb-1.5 pt-[max(env(safe-area-inset-top),6px)]">
        <button
          type="button"
          onClick={() => setSwitchOpen(true)}
          disabled={loading}
          aria-label={t("nav.currentAccountAria", { name: accountName })}
          className="flex h-11 min-w-0 max-w-full items-center gap-1.5 rounded-xl px-2 text-left transition-colors active:bg-hover disabled:opacity-60"
        >
          <span className="truncate text-[15px] font-semibold text-foreground">
            {loading && !currentAccount ? t("nav.loading") : accountName}
          </span>
          <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" />
        </button>
      </header>

      <MobileAccountSwitchSheet
        open={switchOpen}
        onOpenChange={setSwitchOpen}
        accounts={accounts}
        currentAccountId={currentAccount?.id}
        loading={loading}
        onSwitch={switchAccount}
      />
    </>
  );
};
